import request from "@/utils/request.js";

// 预签名URL上传文件（预签名URL:5分钟后失效）
export const getSignatureUrl = (formData) => {
    return request.get(`/upload/signatureUrl`, {params: formData})
}
// 预签名URL上传视频文件（预签名URL:5分钟后失效）
export const getSignatureVideoUrl = (formData) => {
    return request.get(`/upload/video/signatureUrl`, {params: formData})
}
